<h3>
  <span *ngFor="let unit of units" [style.color]="unit.color.toRgbString()">
    <span *ngFor="let vehicle of unit.vehicles"> {{ vehicle.VehicleCode }} </span>
  </span>
</h3>
